import moment, { Moment } from "moment";
import couponModel from "../static/coupon.model";

export function getCouponsTypeDescription(
  data:couponModel
) {
  switch (data.couponType) {
    case "COUPON_PRODUCT_RowDiscount_Percentage":
      return (
        "Acquistando " +
        getEntita(data.promotedProducts, data.promotedCategories, data.promotedSuppliers) +
        " viene applicato uno sconto del " +
        data.value +
        "%"
      );
    case "COUPON_PRODUCT_RowDiscount_Value":
      return (
        "Acquistando " +
        getEntita(data.promotedProducts, data.promotedCategories, data.promotedSuppliers) +
        " viene applicato uno sconto di " +
        currencyFormat(data.value)
      );
    case "COUPON_PRODUCT_Row32":
      return (
        "Acquistando 3 pezzi di " +
        getEntita(data.promotedProducts, data.promotedCategories, data.promotedSuppliers) +
        " uno &egrave; gratis " +
        getEntita(data.promotedProducts, data.promotedCategories, data.promotedSuppliers)
      );
    case "COUPON_PRODUCT_AddPoint":
      return (
        "Acquistando " +
        getEntita(data.promotedProducts, data.promotedCategories, data.promotedSuppliers) +
        " vengono accreditati " +
        data.value +
        " punti bonus"
      );
    case "COUPON_PRODUCT_CheckDiscount_Percentage":
      return (
        "Acquistando " +
        getEntita(data.promotedProducts, data.promotedCategories, data.promotedSuppliers) +
        " viene applicato uno sconto del " +
        data.value +
        "% sullo scontrino"
      );
    case "COUPON_PRODUCT_CheckDiscount_Value":
      return (
        "Acquistando " +
       getEntita(data.promotedProducts, data.promotedCategories, data.promotedSuppliers) +
        " viene applicato uno sconto di " +
        currencyFormat(data.value) +
        " sullo scontrino"
      );
    case "COUPON_PRODUCT_11":
      return (
        "Acquistando 2 pezzi di " +
        getEntita(data.promotedProducts, data.promotedCategories, data.promotedSuppliers) +
        " uno &egrave; gratis"
      );
    case "COUPON_PRODUCT_MULTI":
      return (
        "Acquistando " +
        getEntita(data.promotedProducts, data.promotedCategories, data.promotedSuppliers) +
        " i punti per esso accreditati sono moltiplicati per " +
        data.value
      );
    case "COUPON_CAT_RowDiscount_Value":
      return (
        "Acquistando un prodotto " +
        getEntita(data.promotedProducts, data.promotedCategories, data.promotedSuppliers) +
        " viene applicato uno sconto di " +
        currencyFormat(data.value)
      );
    case "COUPON_CAT_AddPoint":
      return (
        "Acquistando un prodotto " +
        getEntita(data.promotedProducts, data.promotedCategories, data.promotedSuppliers) +
        " vengono accreditati " +
        data.value +
        " punti bonus"
      );
    case "COUPON_CAT_CheckDiscount_Percentage":
      return (
        "Acquistando un prodotto " +
        getEntita(data.promotedProducts, data.promotedCategories, data.promotedSuppliers) +
        " vengono accreditati " +
        data.value +
        " punti bonus"
      );
    case "COUPON_CAT_CheckDiscount_Value":
      return (
        "Acquistando un prodotto " +
        getEntita(data.promotedProducts, data.promotedCategories, data.promotedSuppliers) +
        " viene applicato uno sconto di " +
        currencyFormat(data.value) +
        " sullo scontrino"
      );
    case "COUPON_CAT_MULTI":
      return (
        "Acquistando un prodotto " +
        getEntita(data.promotedProducts, data.promotedCategories, data.promotedSuppliers) +
        " i punti per esso accreditati sono moltiplicati per " +
        data.value
      );
    case "COUPON_SUP_RowDiscount_Percentage":
      return (
        "Acquistando un prodotto " +
        getEntita(data.promotedProducts, data.promotedCategories, data.promotedSuppliers) +
        " viene applicato uno sconto del " +
        data.value +
        "%"
      );
    case "COUPON_SUP_RowDiscount_Value":
      return (
        "Acquistando un prodotto " +
        getEntita(data.promotedProducts, data.promotedCategories, data.promotedSuppliers) +
        " viene applicato uno sconto di " +
        currencyFormat(data.value)
      );
    case "COUPON_SUP_AddPoint":
      return (
        "Acquistando un prodotto " +
        getEntita(data.promotedProducts, data.promotedCategories, data.promotedSuppliers) +
        " vengono accreditati " +
        data.value +
        " punti bonus"
      );
    case "COUPON_SUP_CheckDiscount_Percentage":
      return (
        "Acquistando un prodotto " +
        getEntita(data.promotedProducts, data.promotedCategories, data.promotedSuppliers) +
        " viene applicato uno sconto del " +
        data.value +
        "% sullo scontrino"
      );
    case "COUPON_SUP_CheckDiscount_Value":
      return (
        "Acquistando un prodotto " +
        getEntita(data.promotedProducts, data.promotedCategories, data.promotedSuppliers) +
        " viene applicato uno sconto di " +
        currencyFormat(data.value) +
        " sullo scontrino"
      );
    case "COUPON_SUP_MULTI":
      return (
        "Acquistando un prodotto " +
        getEntita(data.promotedProducts, data.promotedCategories, data.promotedSuppliers) +
        " i punti per esso accreditati sono moltiplicati per " +
        data.value
      );

      case "COUPON_CAT_RowDiscount_Percentage":
        return(
          "Acquistando un prodotto " +
          getEntita(data.promotedProducts, data.promotedCategories, data.promotedSuppliers) +
          " viene applicato uno sconto del " +
          data.value +
          "%"
          )
    default:
      return "";
  }
}

// const getEntita = (
//   promotedProducts: string[],
//   promotedCategories: string[],
//   promotedSuppliers: string[]
// ) => {
//   let result = "";
//   if (promotedProducts.length > 0) {
//     return promotedProducts.join(", ");
//   }

//   if (promotedCategories.length > 0) {
//     if (promotedCategories.length > 1) {
//       result = " delle categorie " + promotedCategories.join(", ");
//     } else {
//       result = " della categoria " + promotedCategories[0];
//     }
//   }

//   if (promotedSuppliers.length > 0) {
//     if (promotedSuppliers.length > 1) {
//       result += " delle ditte " + promotedSuppliers.join(", ");
//     } else {
//       result += " della ditta " + promotedSuppliers[0];
//     }
//   }

//   return result;
// };

const getEntita = (
  promotedProducts: string[],
  promotedCategories: string[],
  promotedSuppliers: string[]
) => {
  let result = "";

  if (promotedProducts.length > 0) {
    return promotedProducts.join(", ");
  }

  if (promotedSuppliers.length > 0) {
    if (promotedSuppliers.length > 1) {
      result += " delle ditte " + promotedSuppliers.join(", ");
    } else {
      result += " della ditta " + promotedSuppliers[0];
    }

    if (promotedCategories.length > 0) {
      result += " e appartenente";

      if (promotedCategories.length > 1) {
        result += " alle categorie " + promotedCategories.join(", ");
      } else {
        result += " alla categoria " + promotedCategories[0];
      }
    }

    return result;
  }

  if (promotedCategories.length > 0) {
    if (promotedCategories.length === 1) {
      result = " della categoria " + promotedCategories[0];
    } else {
      result = " delle categorie " + promotedCategories.join(", ");
    }
  }

  return result;
};

//-------------------------------------------

const currencyFormat = (value: number) => {
  return value + " €";
};

export function getValoreCoupons(tipo: string, valore: number): string {
  switch (tipo) {
    case "COUPON_PRODUCT_RowDiscount_Percentage":
    case "COUPON_PRODUCT_CheckDiscount_Percentage":
    case "COUPON_PRODUCT_CheckDiscount_Value":
    case "COUPON_CAT_RowDiscount_Percentage":
    case "COUPON_CAT_CheckDiscount_Percentage":
    case "COUPON_SUP_RowDiscount_Percentage":
    case "COUPON_SUP_CheckDiscount_Percentage":
      return "vale il " + valore + " %";
    case "COUPON_PRODUCT_RowDiscount_Value":    
    case "COUPON_CAT_RowDiscount_Value":
    case "COUPON_CAT_CheckDiscount_Value":
    case "COUPON_SUP_RowDiscount_Value":
    case "COUPON_SUP_CheckDiscount_Value":
      return "vale " + currencyFormat(valore);
    case "COUPON_PRODUCT_MULTI":
    case "COUPON_CAT_MULTI":
    case "COUPON_SUP_MULTI":
      return "moltiplica x" + valore + "i tuoi punti";
    case "COUPON_PRODUCT_Row32":
      return "3x2";
    case "COUPON_PRODUCT_AddPoint":
    case "COUPON_CAT_AddPoint":
    case "COUPON_SUP_AddPoint":
      return "vale " + valore + " punti";
    case "COUPON_PRODUCT_11":
      return "promozione 1+1";
    default:
      return "";
  }
}

export function getCouponsDate(data: couponModel) {
  if(data.isInfoCoupon){
    return '';
  } else {
    if (data.issuingDate) {
      // qui, se si vuole essere un po' più precisi, nella condizione "else" dell'operatore if, invece di restituire data.redemptionTo è preferibile restituire
      // la maggiore tra data.issuingDate e data.redemptionTo in modo da ottenere sempre una data maggiore o uguale alla data di emissione
      return (
        <div className="flex flex-row flex-wrap">
          <div className="flex align-items-end justify-content-start ">
            <div className="text-left font-bold" style={{ fontSize: "10px" }}>
              PUOI UTILIZZARLO DAL
            </div>
            <div className=" ml-2 text-left font-bold">
              {data.isDynamicRedemption ? moment(data.issuingDate).format("DD/MM/YYYY") : moment(data.redemptionFrom).format("DD/MM/YYYY")}
            </div>
            <div style={{ fontSize: "10px" }} className="ml-2 text-right font-bold">
              AL
            </div>
            <div className="ml-2 text-left font-bold">
              {moment(data.redemptionWithinDate).format("DD/MM/YYYY")}
            </div>
          </div>
        </div>
      ); //return ("utilizzabile dal " + moment(data.isDynamicRedemption ? data.issuingDate : data.redemptionTo).format("DD/MM/YYYY") + " al " + moment(data.redemptionWithinDate).format("DD/MM/YYYY"));
    } else {
      return (
        <div className="flex flex-row flex-wrap">
          <div className="flex align-items-end justify-content-start ">
            <div className="text-left font-bold" style={{ fontSize: "10px" }}>
              PUOI OTTENERLO DAL
            </div>
            <div className=" ml-2 text-left font-bold">
              {moment(data.issuingFrom).format("DD/MM/YYYY")}
            </div>
            <div style={{ fontSize: "10px" }} className="ml-2 text-right font-bold">
              AL
            </div>
            <div className="ml-2 text-left font-bold">
              {moment(data.issuingTo).format("DD/MM/YYYY")}
            </div>
          </div>
        </div>
      ); //"ottenibile dal "+moment(data.issuingFrom).format("DD/MM/YYYY")+" al "+moment(data.issuingTo).format("DD/MM/YYYY");
    }
  }
  
}

type Days = {
  monday: boolean;
  tuesday: boolean;
  wednesday: boolean;
  thursday: boolean;
  friday: boolean;
  saturday: boolean;
  sunday: boolean;
};

const getDays = (day: string) => {
  switch (day) {
    case "monday":
      return "lunedì";
    case "tuesday":
      return "martedì";
    case "wednesday":
      return "mercoledì";
    case "thursday":
      return "giovedì";
    case "friday":
      return "venerdì";
    case "saturday":
      return "sabato";
    case "sunday":
      return "domenica";
    default:
      return "";
  }
};

export function getStatusCouponTime(data: couponModel) {
  let _tempStartDate;
  let _tempEndDate;
  if (data.issuingDate) {
    _tempStartDate = data.isDynamicRedemption
      ? moment(data.issuingDate)
      : data.redemptionTo;
    _tempEndDate = moment(data.redemptionWithinDate);
  } else {
    _tempStartDate = moment(data.issuingFrom);
    _tempEndDate = moment(data.issuingTo);
  }
  let _tempDiff = _tempEndDate.diff(_tempStartDate, "days");
  console.log("coupon che dura " + _tempDiff + " giorni");
  let today = moment();
  if (_tempDiff > 365) {
    let diff = _tempDiff * 0.1;
    if (_tempEndDate.diff(today, "days") <= diff) {
      return "#ff7800"; //"orange";
    } else {
      return "green";
    }
  } else {
    let diff = _tempDiff * 0.25;
    if (_tempEndDate.diff(today, "days") <= diff) {
      return "#ff7800"; //"orange";
    } else {
      return "green";
    }
  }
}
